export default __webpack_public_path__ + "static/media/scroll.543563f3.svg";